import styled from 'styled-components';
import Form from 'antd/es/form/Form';
import { CardBody } from '../../common/Card';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

export const BookingForm = styled(Form)`
  .ant-form-item {
    margin-bottom: ${SPACING.xl};
  }

  .ant-form-item-label {
    padding-bottom: 5px;
  }

  .ant-form-item-label > label {
    height: auto;
    font-size: ${FONT_SIZE.label};
    font-weight: 500;
    line-height: 1.4;
    color: ${COLOR.text};
  }

  .ant-form-item-extra {
    margin-top: ${SPACING.xs};
    font-size: ${FONT_SIZE.hint};
    line-height: 1.5;
    color: ${COLOR.textSecondary};
  }

  .ant-input,
  .ant-picker,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px;
    border-radius: ${RADIUS.md};
    border-color: ${COLOR.border};
    font-size: ${FONT_SIZE.value};
    color: ${COLOR.text};
  }

  .ant-picker,
  .ant-select {
    width: 100%;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px;
  }

  .ant-input:hover,
  .ant-picker:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${COLOR.primary};
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-picker-focused,
  .ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
    border-color: ${COLOR.primary};
    box-shadow: 0 0 0 1.5px ${COLOR.primary};
  }

  .ant-form-item-has-error .ant-input,
  .ant-form-item-has-error .ant-picker,
  .ant-form-item-has-error .ant-select .ant-select-selector {
    border-color: ${COLOR.errorBorder};
  }
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 ${SPACING.lg};
  /* Don't stretch the form items: antd sizes the label and input at
     flex-basis 100%, which against a stretched (definite) height puts the
     input beside its label and pushes it off a phone's screen. */
  align-items: start;

  > .ant-form-item {
    min-width: 0;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;

    /* Stacked, only the row's last item may drop its gap at the card's end. */
    && > .ant-form-item:not(:last-child) {
      margin-bottom: ${SPACING.xl};
    }
  }
`;

export const FormCardBody = styled(CardBody)`
  > .ant-form-item:last-child,
  > *:last-child .ant-form-item {
    margin-bottom: 0;
  }
`;
